__turbopack_context__.v({
  "graphs": "Pricelists-module-scss-module__aeCm9G__graphs",
  "pricelists": "Pricelists-module-scss-module__aeCm9G__pricelists",
});
